import type { RatingItem } from "@/types";

export function RatingItem({
  name,
  ratingNumber
}: RatingItem) {
  return(
    <li className="flex">
      <p>{name}</p>
      <span className="rating"><svg height="1em" className="icon-inline">
        <circle cx="0.5em" cy="0.5em" r="0.5em" fill={(ratingNumber >= 1)? "white" : "var(--clr-primary-400)"}></circle>
      </svg>
      <svg height="1em" className="icon-inline">
        <circle cx="0.5em" cy="0.5em" r="0.5em" fill={(ratingNumber >= 2)? "white" : "var(--clr-primary-400)"}></circle>
      </svg>
      <svg height="1em" className="icon-inline">
        <circle cx="0.5em" cy="0.5em" r="0.5em" fill={(ratingNumber >= 3)? "white" : "var(--clr-primary-400)"}></circle>
      </svg>
      <svg height="1em" className="icon-inline">
        <circle cx="0.5em" cy="0.5em" r="0.5em" fill={(ratingNumber >= 4)? "white" : "var(--clr-primary-400)"}></circle>
      </svg>
      <svg height="1em" className="icon-inline">
        <circle cx="0.5em" cy="0.5em" r="0.5em" fill={(ratingNumber >= 5)? "white" : "var(--clr-primary-400)"}></circle>
      </svg></span>
    </li>
  )
}